<template>
  <div class="referral-chain">
    <div v-for="(item, index) in referralChainInfo" :key="item.rc_id" :style="'z-index:' + index">
        <template v-if="need_ellipsis && index == 2">
          <div class="referral-chain-photo">
            <van-icon class="referral-chain-ellipsis" name="ellipsis" />
          </div>
        </template>
        <template v-else-if="( index < 2 ) || !need_ellipsis || ((referralChainInfo.length - index) <= 2)">
          <div class="referral-chain-photo">
            <img
              :class="{self: index == referralChainInfo.length - 1}"
              :src="[item.is_candidate ? $DjangoMediaUrl(item.profile_image_url) : item.profile_image_url ]"
              :title="item.name"
              @error="getDefaultProfilePhoto($event)"
              />
          </div>
        </template>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    referralChainInfo: {
      type: Array,
      require: true
    }
  },
  data () {
    return {
      need_ellipsis: false
    }
  },
  created () {
    if (this.referralChainInfo.length >= 5) {
      this.need_ellipsis = true
    }
  },
  mounted () {
  },
  methods: {
    getDefaultProfilePhoto (e) {
      e.target.src = this.$DjangoStaticUrl('images_en/default.jpg')
    }
  }
}
</script>

<style lang="scss" scoped>
.referral-chain {
  display: flex;

  .referral-chain-photo {
    border: 1px solid white;
    border-radius: 50%;
    width: 26px;
    height: 26px;
    overflow: hidden;
    margin-left: -5px;
    box-shadow: 2px 1px 4px 0px #a8b2b5;

    > img {
      border-radius: 50%;
      border: 1px solid white;
      width: 24px;
      height: 24px;
      vertical-align: middle;
    }
  }

  .self {
    box-shadow: 0 0 0px 2px #0296cc;
  }

  .referral-chain-ellipsis {
    padding-top: 7px;
    background: #FFFFFF;
    width: 26px;
    height: 26px;
    vertical-align: middle;
    text-align: center;
  }
}
</style>
